module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_arface.0affcc8f.jpg";